<app-redirect-popup *ngIf="showRedirectPopup" class="cover-all" [userName]="userName" [channelUrl]="channelUrl" [valleyUrl]="valleyUrl" [academyUrl]="academyUrl" (popupBtn)="onClickPoupBtn($event)" (logoutBtn)="onClickLogoutBtn($event)" (closePopup)="closeRedirectPopup()"></app-redirect-popup>
<div class="d-flex home-div">
  <div class="col-lg-7 home-left-side"><app-information [buttonText]="'Sign up'" (buttonClick)="buttonClickSignup()"></app-information></div>
  <div class="col-lg-5 no-padding home-right-side">
    <app-login (checkRedirectPopup)=checkRedirectPopup($event) [onClickSignup]="ClickSignup"></app-login>
  </div>
</div>
<app-query-params-ls></app-query-params-ls>
